import React from "react";
import SportsList from "../../components/sportsList";
import SportsBookWrapper from "../sportsBookWrapper";
import FavoritesGamesList from "../../components/favoritesGamesList";
import PredefinedMultiples from "../../components/predefinedMultiples";

export default function todayTemplate () {
    let isAsian = this.props.isAsian,
        { sportAlias, regionId, competitionId } = this.props.routeParams,
        gameType = "today";
    return (<div className={`import-view-container ${!isAsian ? "sport-view-wrapper" : "asian-view"}`} onClick={this.handleClick()}>
        <SportsList sportAlias={sportAlias}
                    location={this.props.location}
                    gameType={gameType}
                    isAsian={isAsian}/>
        {
            sportAlias && sportAlias === "multiples" &&
            <PredefinedMultiples />
        }
        {
            sportAlias && sportAlias !== "Favorites" && sportAlias !== "multiples" && <SportsBookWrapper sportAlias={sportAlias}
                                                                           isAsian={isAsian}
                                                                           regionId={regionId}
                                                                           competitionId={competitionId}
                                                                           gameType={gameType}
                                                                           child={this.props.children}/>
        }
        {
            sportAlias && sportAlias === "Favorites" && <FavoritesGamesList/>
        }
    </div>);
};